import { Component, EventEmitter, HostListener, Input, Output, TrackByFunction } from '@angular/core';
import { ContextMenuItem } from '../../models/conversation.model';

export { ContextMenuItem };

@Component({
	selector: 'app-context-menu',
	template: `
		<div *ngIf="visible" class="context-menu" [style.left.px]="x" [style.top.px]="y" (click)="$event.stopPropagation()" data-testid="context-menu-container">
			<ng-container *ngFor="let item of items; trackBy: trackById">
				<div *ngIf="item.dividerBefore" class="context-menu-divider"></div>
				<button class="context-menu-item" [class.context-menu-item--danger]="item.danger" (click)="onItemClick(item.id)" [attr.data-testid]="'context-menu-btn-' + item.id">
					<mat-icon>{{ item.icon }}</mat-icon>
					{{ item.label }}
				</button>
			</ng-container>
		</div>
	`,
	styleUrls: ['./context-menu.component.scss'],
})
export class ContextMenuComponent {
	@Input() items: ContextMenuItem[] = [];
	@Input() x = 0;
	@Input() y = 0;
	@Input() visible = false;
	@Output() itemClicked = new EventEmitter<string>();
	@Output() closed = new EventEmitter<void>();

	/** Track menu items by their stable id to prevent DOM re-creation during change detection */
	trackById: TrackByFunction<ContextMenuItem> = (_index, item) => item.id;

	/** Auto-close when user clicks anywhere on the document */
	@HostListener('document:click')
	onDocumentClick(): void {
		if (this.visible) {
			this.visible = false;
			this.closed.emit();
		}
	}

	/** Emit the action ID and close the menu */
	onItemClick(actionId: string): void {
		this.itemClicked.emit(actionId);
		this.visible = false;
		this.closed.emit();
	}
}
